// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer{position:relative;margin:0 auto;width:68rem;padding:32px 0;text-align:right}", ""]);
// Exports
module.exports = exports;
